import Component from 'gia/Component'
import render from '../components/render'
import stage from '../components/stage'
import _each from 'lodash.foreach'

class  Sticky extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element
    this.el = $(element)

    this.options = {
        t: 1.5,
        y: 0
    };

    this.ref = {
      sticky: null,
      sketch: [],
      box: []
    }

  }


  mount() {
    //console.log("Mount Sticky!");



    this.resizeQue = this.resize.bind(this)
    stage.on("stage:resize", this.resizeQue);
    this.renderQue = this.render.bind(this)
    stage.on("stage:scroll", this.renderQue);
    this.resize(stage);
  }

  unmount() {
    //console.log("Unmount Sticky!");

    stage.removeAllListeners();

  }


  resize(e){

    this.h = e.h/2
    this.element.dataset.top = this.el.offset().top + this.options.y
    this.element.dataset.height = this.el.height()





    this.render(stage)

  }


  render(e){

      const scroll = e.scrolltop - this.element.dataset.top ;
      const scrollh = e.scrolltop - this.element.dataset.top - this.element.dataset.height;



      if(scroll >= 0 && scrollh < 0){
        TweenMax.set(this.ref.sticky,{ y: -scroll*.75, force3D: true})
      }
      else {
        TweenMax.set(this.ref.sticky,{ y: 0, force3D: true})
      }





  }


}

module.exports = Sticky
